module.exports = __webpack_public_path__ + "img/3.331ded10.png";